// extracted by mini-css-extract-plugin
export var container = "layout-module--container--78b04";
export var fadein = "layout-module--fadein--7278b";
export var heading = "layout-module--heading--f158c";
export var landingPage = "layout-module--landing-page--0e8f7";
export var navWrap = "layout-module--nav-wrap--cc604";
export var note = "layout-module--note--27a8d";
export var verticalFlexContainer = "layout-module--vertical-flex-container--7512b";
export var wrapCenteredFlex = "layout-module--wrap-centered-flex--c0945";